import React from 'react';
import CaseStudyLayout from '@/components/CaseStudyLayout';

const TechStartZurichCase = () => {
  const caseStudy = {
    id: 'techstart-zuerich',
    company: 'TechStart Zürich',
    industry: 'Tech Startup',
    service: 'AI-Video + SEO Strategie',
    duration: '6 Monate',
    image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
    challenge: 'Als junges Zürcher Tech-Startup hatte TechStart Schwierigkeiten, sich in einem überfüllten Markt zu positionieren. Trotz innovativer Softwarelösung war die Online-Sichtbarkeit gering, und komplexe B2B-Verkaufsprozesse führten zu wenigen qualifizierten Leads. Die vorhandene Website generierte nur 2.400 monatliche Besucher bei einer mageren Conversion-Rate von 1.2%.',
    solution: 'Wir entwickelten eine integrierte Strategie aus lokalem SEO für den Zürcher Markt und AI-generierten Erklärvideos. Die Videos erklärten komplexe Softwarefeatures verständlich, während gezieltes SEO für Begriffe wie "Software Zürich" und "B2B-Lösungen Schweiz" sorgte. Zusätzlich optimierten wir die gesamte Customer Journey mit personalisierten Landing Pages.',
    results: {
      traffic: { before: '2,400', after: '12,800' },
      leads: { before: '8', after: '45' },
      conversion: { before: '1.2%', after: '3.8%' }
    },
    testimonial: {
      quote: 'Future Level hat unser B2B-Marketing revolutioniert. Die AI-Videos erklären unsere Software so verständlich, dass Interessenten bereits vor dem ersten Gespräch wissen, was wir bieten. Der ROI war bereits nach 3 Monaten erreicht.',
      author: 'Sarah Müller',
      position: 'CMO, TechStart Zürich'
    }
  };

  return <CaseStudyLayout caseStudy={caseStudy} />;
};

export default TechStartZurichCase;